import React from "react";
import "./styles.scss";


const DefaultLoader = () => (
  <div className="loading" role="status">
    <div className="infinite-loader"></div>
  </div>
);


export default DefaultLoader;
